export default __webpack_public_path__ + "assets/5f5a6fabf217efd0a7bb664314c0ceb0.svg";